import clsx from "clsx";
import React from "react";

import * as ReactUtils from "../../../../lib/util/ReactUtils";
import FocusBlocker from "../../../util/FocusBlocker/FocusBlocker";

const VisibleContext = ReactUtils.VisibleContext;

export default class DesktopNavBar extends React.PureComponent {
	menuItems = React.createRef();
	panel = React.createRef();
	observer = null;

	componentWillUnmount() {
		if (!this.observer) {
			return;
		}

		this.observer.disconnect();
	}

	render() {
		const {
			isMobile,
			searchIsActive,
			logo,
			groups,
			MenuItems,
			visible,
			navUser,
			navSupport,
			navLocale,
			searchBar,
			multiLevel,
			fleets,
		} = this.props;

		if (visible) {
			this.shown = true;
		}

		if (!this.shown) return null;

		return (
			<FocusBlocker active={!visible}>
				<div className={"Navigation__desktop-bar-wrapper"}>
					<div
						className={clsx(
							"Navigation__desktop-bar",
							isMobile && "--mobile",
							multiLevel && "--multiLevel",
						)}
					>
						<VisibleContext.Provider value={visible}>
							<div className={"Navigation__inner-left-container"}>
								{logo}
								<div className={"Navigation__fleets"}></div>
								<div className={"Navigation__fleets"}>
									{fleets &&
										React.cloneElement(fleets, {
											onAnimationEnd: (e) => {
												if (e.animationName !== "slideIn") {
													return;
												}

												this.setState({ itemsOffset: 0 }, this.onResize);
											},
										})}
								</div>
								<div className={"Navigation__groups"}>
									{groups &&
										React.cloneElement(groups, {
											onAnimationEnd: (e) => {
												if (e.animationName !== "slideIn") {
													return;
												}

												this.setState({ itemsOffset: 0 }, this.onResize);
											},
										})}
								</div>
								{!multiLevel && (
									<div
										className={clsx(
											"Navigation__MenuItems-container",
											isMobile && "-isMobile",
										)}
										ref={this.menuItems}
									>
										{MenuItems}
									</div>
								)}
							</div>
							<div className={"Navigation__panel"} ref={this.panel}>
								<div
									className={clsx("Navigation__panel-inner", {
										"--hidden": searchIsActive,
									})}
								>
									<VisibleContext.Provider value={!searchIsActive}>
										{navUser}
										{navSupport}
										{navLocale}
									</VisibleContext.Provider>
								</div>
								{searchBar}
							</div>
						</VisibleContext.Provider>
					</div>
				</div>
				{multiLevel && (
					<div className={"Navigation__level-2"}>
						<div
							className={clsx(
								"Navigation__MenuItems-container",
								isMobile && "-isMobile",
							)}
							ref={this.menuItems}
						>
							{MenuItems}
						</div>
					</div>
				)}
			</FocusBlocker>
		);
	}
}
